import { WsSelectObj } from 'wisestep-base';

export const visaOptions: WsSelectObj[] = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'H-1B',
    value: 'H-1B',
  },
  {
    label: 'Green Card',
    value: 'GREEN CARD',
  },
  {
    label: 'Green Card EAD',
    value: 'GREEN CARD EAD',
  },
  {
    label: 'Citizen',
    value: 'CITIZEN',
  },
  {
    label: 'OPT',
    value: 'OPT',
  },
  {
    label: 'CPT',
    value: 'CPT',
  },
  {
    label: 'E3',
    value: 'E3',
  },
  {
    label: 'L2-EAD',
    value: 'L2-EAD',
  },
  {
    label: 'TN-VISA',
    value: 'TN-VISA',
  },
  {
    label: 'H4-EAD',
    value: 'H4-EAD',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];
